import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { SnowplowContext } from '@cred/react-analytics/SnowplowContextManager'
import { component as SpComponent } from '@cred/react-analytics/contexts'

import { EmptyList } from 'components/empty-list'
import WidgetContext from 'components/widget-context'

import { getLenderTileComponent, compareLendersRate } from './utils'
import styles from './styles.module.scss'

/* Sort lenders by minimum APR. */
const sortLenders = (lenders, compareFn) => lenders.sort(compareFn)

const renderLendersList = ({
  sortedLenders,
  ctaUrl,
  theme,
  name,
  className = '',
  openUrlInNewTab,
  otherOptions,
}) => {
  const isMultiVertical = name.includes('multiVertical')
  const LenderTile = getLenderTileComponent(name)

  return (
    <WidgetContext.Consumer>
      {(value) => (
        <div className={cx({ [styles.lenderListContainer]: !isMultiVertical }, [className])}>
          {sortedLenders.map((lender, i) => (
            <SnowplowContext
              contexts={[SpComponent.analytics({ name: lender.name })]}
              key={`lender-rate-${lender.slug}`}
            >
              <LenderTile
                index={i}
                tileName={name}
                ctaUrl={ctaUrl}
                blank={openUrlInNewTab}
                key={`lender-rate-${lender.slug}`}
                lender={lender}
                widgetContext={value}
                theme={theme}
                otherOptions={otherOptions}
              />
            </SnowplowContext>
          ))}
        </div>
      )}
    </WidgetContext.Consumer>
  )
}

const LendersList = ({
  resetFilters = () => {},
  lenders = [],
  ctaUrl = '',
  theme,
  name,
  compareFn = compareLendersRate,
  className,
  openUrlInNewTab = true,
  otherOptions,
}) => {
  const sortedLenders = sortLenders(lenders, compareFn)

  return sortedLenders.length === 0 ? (
    <EmptyList resetFilters={resetFilters} />
  ) : (
    renderLendersList({
      sortedLenders,
      ctaUrl,
      theme,
      name,
      className,
      openUrlInNewTab,
      otherOptions,
    })
  )
}

LendersList.propTypes = {
  name: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  ctaUrl: PropTypes.string,
  resetFilters: PropTypes.func,
  lenders: PropTypes.instanceOf(Array),
  compareFn: PropTypes.func,
  className: PropTypes.string,
  openUrlInNewTab: PropTypes.bool,
  otherOptions: PropTypes.string,
}

export { LendersList, sortLenders, compareLendersRate, renderLendersList }

export default LendersList
